/** Легенда трека судна: что значат цвета и сколько времени ушло на что.
 *
 *  Без неё трек — просто разноцветная нитка. Легенда строится по ТОМУ, ЧТО ЕСТЬ
 *  в ответе (`meta.hours`), а не по полному словарю операций: шесть строк, из
 *  которых заняты две, читаются как «остального не было».
 *
 *  Здесь же живёт «Скрыть»: карточка судна закрывается кликом мимо, и без этой
 *  кнопки убрать трек было бы нечем — пришлось бы искать судно заново. */
import { formatNumber, useLang, useT } from '../i18n'
import { operationHours } from '../map/vesselOps'

export function VesselTrackLegend({
  name,
  from,
  to,
  hours,
  onHide,
}: {
  name: string
  from: string
  to: string
  hours?: Record<string, number>
  onHide: () => void
}) {
  const t = useT()
  const { lang } = useLang()
  const rows = operationHours(hours)
  return (
    <div className="min-w-[210px] rounded-xl border border-hull bg-abyss/85 px-3.5 py-3 shadow-console backdrop-blur">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="truncate text-xs font-semibold text-foam" title={name}>
            {t('models.vesselTrack.title', { name })}
          </div>
          <div className="tnum text-[10px] text-faint">
            {from} — {to}
          </div>
        </div>
        <button
          type="button"
          onClick={onHide}
          className="shrink-0 rounded-md border border-hull px-1.5 py-0.5 text-[10px] text-mist transition-colors hover:bg-haze hover:text-foam"
        >
          {t('models.vesselTrack.hide')}
        </button>
      </div>

      {rows.length > 0 ? (
        <div className="mt-2 space-y-1 text-[11px] text-mist">
          {rows.map(r => (
            <div key={r.operation} className="flex items-center justify-between gap-3">
              <span className="flex min-w-0 items-center gap-1.5">
                <span
                  className="inline-block h-0.5 w-4 shrink-0 rounded"
                  style={{ background: r.color }}
                />
                <span className="truncate">{r.label}</span>
              </span>
              <span className="tnum shrink-0 text-faint">
                {t('obs.hours', { value: formatNumber(lang, r.hours, 1) })}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <div className="mt-2 text-[11px] text-faint">{t('models.vesselTrack.emptyPeriod')}</div>
      )}
    </div>
  )
}
